import { FESTIVAL } from '../../data/full/festival';
import type { SimEvent, SimState } from '../../sim/state';
import { Bursts } from '../bursts';
import type { Family, RenderContext } from '../context';
import type { Frame } from '../frame';
import { byId } from '../util';

const SHARDS = 6;
const CAPACITY = 64;

// A trap still placed when a stage holds bursts in its owner's colour, as far as it throws its vibes.
export function createTrapBursts(ctx: RenderContext): Family {
  const { textures: t, layers } = ctx;
  const bursts = new Bursts(layers.fx, CAPACITY, t.ring);
  const { radius } = FESTIVAL.trapVibes;

  return {
    onEvent(event: SimEvent, state: SimState, frame: Frame): void {
      if (event.type !== 'trapBurst') {
        return;
      }
      const owner = byId(state.players, event.playerId);
      const token = owner === undefined ? undefined : ctx.classTokens.get(owner.classId);
      const tint = frame.palette[token ?? 'or'];
      const peak = frame.calm ? 0.5 : 0.9;
      const duration = frame.tempo.ticksPerBeat;
      const { x, y } = event;
      const now = state.tick;
      bursts.spawn({
        shape: t.ring,
        now,
        duration,
        x,
        y,
        fromRadius: 6,
        toRadius: radius,
        tint,
        peak,
      });
      for (let shard = 0; shard < SHARDS; shard++) {
        const angle = event.id + (shard / SHARDS) * 2 * Math.PI;
        bursts.spawn({
          shape: t.shard,
          now,
          duration,
          x,
          y,
          dx: Math.cos(angle) * radius * 0.8,
          dy: Math.sin(angle) * radius * 0.8,
          fromRadius: 11,
          toRadius: 5,
          tint,
          peak,
          angle,
          spin: frame.calm ? 0 : 3,
        });
      }
    },
    update(state: SimState, alpha: number, frame: Frame): void {
      bursts.update(state, alpha, frame);
    },
    reset: () => {
      bursts.clear();
    },
    destroy: () => {
      bursts.clear();
    },
  };
}
